export enum RemarketEligibilityStatus {
    Eligible = 'Eligible',
    NotEligible = 'NotEligible',
}
